export const APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
